<template>
  <li>
    <button
      :class="$style.button"
      :active-class="$style.isActive"
      @click="redirect"
      type="button"
    >
      <base-icon :class="$style.icon" name="stake" themeSize="xx-large" />
      <span :class="$style.label">Stake</span>
    </button>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import auth from '@/services/auth'
import config from '@/services/config'
import store from '@/store'

export default {
  computed: {
    ...mapState(['profile'])
  },
  methods: {
    redirect() {
      const email = this.profile.email
      return this.withModalLoading(
        auth
          .getNonce()
          .then(function ({ nonce }) {
            window.location.replace(
              `${config.consoleV2Url}/redirect/?${new URLSearchParams({
                email,
                nonce
              }).toString()}`
            )
          })
          .catch(err =>
            store.commit('addNotification', {
              message: err.message,
              type: 'error'
            })
          )
      )
    }
  },
  name: 'StakeLink'
}
</script>

<style lang="scss" module>
li:hover {
  cursor: pointer;

  .icon path {
    transition: fill 0.2s;
  }

  .icon path:nth-child(1) {
    fill: #1c224e;
  }

  .icon path:nth-child(2) {
    cursor: pointer;
    fill: #214881;
  }

  .icon path:nth-child(3) {
    cursor: pointer;
    fill: #0065a7;
  }

  .icon path:last-child {
    fill: #048fca;
  }
}

li:hover .label,
li:focus .label {
  color: $color-primary-light;
}

.button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: block;
  font-family: $font-primary;
  min-height: 40px;
  padding-left: spacing(4);
  padding-right: spacing(4);
  text-decoration: none;

  &:hover .label,
  &:focus .label {
    color: $color-primary-light;
  }

  &.isActive {
    padding-left: spacing(3.5);
    border-left: 4px solid $color-primary-light;
    background-image: linear-gradient(
      to right,
      transparent,
      rgba(0, 143, 202, 0.15)
    );
  }
}

.icon {
  transition: fill 0.2s;
  margin-left: 2px;
  margin-right: spacing(3);
  fill: $color-icons;

  path:nth-child(even) {
    fill: #8d8791;
  }
}

.label {
  line-height: 40px;
  font-size: $size-medium;
  font-weight: $weight-regular;
  color: $color-copy;
  transition: color 0.2s;

  .isActive & {
    color: $color-primary-light;
    font-weight: $weight-semibold;
  }
}
</style>
